export default __webpack_public_path__ + "static/media/user.2ffee28a.png";